module.exports = __webpack_public_path__ + "media/images/athletes/1901-972f08309435239beed5b7535440ba90.png";